import React from 'react'
import { useSelector } from 'react-redux'
import { useUserRegion } from '@frontend/components/agromarket/components/RegionSelector'
import { EColor } from '@frontend/pole-ui/lib/common/constants'
import { CommonLink } from '@frontend/pole-ui/lib/components/CommonLink'
import type { TSkeletons } from '@frontend/pole-ui/lib/components/Skeleton'
import { OwnOfferButton } from '@/components/composed/harvestSaleLots'
import { Skeleton, SquareBlock } from '@/components/ui'
import { pushGtmEventOnBlockHarvestSaleCultureClick } from '@/logic/metrika/harvest/helpers'
import { getUserGtmInfo } from '@/logic/metrika/helpers'
import type { RootState } from '@/redux/interfaces'
import { useBlockIntersection } from '@/utils/hooks'
import { getCulturePageUrl, getHarvestSaleLotsUrl } from '@/utils/outputs/url'
import { pushGtmEvent } from './helpers'
import type { IRequestedAvailableCulturesProps } from './interfaces'
import './styles.scss'

const skeletons: TSkeletons = Array(5).fill({
  className: 'square-block index-harvest-sale-requested-item',
  width: null,
  height: null,
  backgroundColor: EColor.WHITE,
  additionalColor: EColor.LIGHT_GRAY,
})

const mapState = (state: RootState) => ({
  userGtmInfo: getUserGtmInfo()(state),
})

const RequestedAvailableCultures: React.FC<IRequestedAvailableCulturesProps> = props => {
  const { title, isLoading = false, availableCultures, isAgrarian, isAuthenticated } = props
  const { blockRef } = useBlockIntersection()
  const { userGtmInfo } = useSelector(mapState)
  const { userRegion } = useUserRegion()

  return (
    <div
      id="harvest"
      className="index-harvest-sale-requested page-wrapper page-wrapper_no-mobile space-holder40-from-sm space-holder32-sm"
      ref={blockRef}
    >
      <div className="row row-align_center row-justify_between space-holder48-from-sm space-holder-top24-from-sm space-holder16-sm">
        <h2>{title}</h2>
        <OwnOfferButton onButtonClick={() => pushGtmEvent(userGtmInfo, userRegion)} sourceOfOpening="previewLotsOutputs" />
      </div>

      <div className="index-harvest-sale-requested-items-container">
        <Skeleton isLoading={isLoading} skeletons={skeletons}>
          {availableCultures?.map(({ id, name }) => (
            <CommonLink
              key={id}
              url={isAgrarian || !isAuthenticated ? getCulturePageUrl(id) : getHarvestSaleLotsUrl(id)}
              activeClassName=""
              className="index-harvest-sale-requested-item"
              onClick={() => pushGtmEventOnBlockHarvestSaleCultureClick(userGtmInfo, userRegion.name, id)}
            >
              <SquareBlock title={name} />
            </CommonLink>
          ))}
        </Skeleton>
      </div>
    </div>
  )
}

export default RequestedAvailableCultures
